import {OptimizerStockLevelMaterialDetailChart} from './detail/OptimizerStockLevelMaterialDetailChart'
import {useSelectedMaterialId} from './SelectedMaterialIdProvider'
import {OptimizerStockLevelsSummary} from './summary/OptimizerStockLevelsSummary'

export const OptimizerStockLevelsCardContent = () => {
  const {materialId} = useSelectedMaterialId()

  return materialId !== undefined ? (
    <OptimizerStockLevelMaterialDetailChart />
  ) : (
    <OptimizerStockLevelsSummary />
  )
}
